import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgFileBigWebp({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 40 40"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M28.25 3.75c1.8 0 3.25 1.46 3.25 3.25v8H29V7a.75.75 0 00-.75-.75h-12.9V12c0 1.65-1.3 3-2.92 3.1H6.5V33c0 .41.34.75.75.75h21c.41 0 .75-.34.75-.75v-3h2.5v3c0 1.8-1.46 3.25-3.25 3.25h-21A3.25 3.25 0 014 33V14c0-.33.13-.65.37-.88l9-9c.23-.24.55-.37.88-.37h14zm-5.9 16.5c.64 0 1.18.13 1.64.4A2.75 2.75 0 0125.36 23c0 .45-.15.76-.44.92-.25.13-.6.19-1.02.19h-2.75l.02.17c.03.16.08.31.15.45a1.22 1.22 0 001.1.69 1.42 1.42 0 00.82-.23l.37-.28.47-.43c.12-.1.27-.14.46-.14.2 0 .38.05.51.17.14.13.21.3.21.51 0 .18-.06.37-.19.59-.12.2-.3.4-.53.58a3.59 3.59 0 01-2.07.63 3.2 3.2 0 01-2.41-.9 3.3 3.3 0 01-.87-2.4c0-.46.07-.9.21-1.3a2.73 2.73 0 011.64-1.74c.4-.16.84-.24 1.32-.24zm4.6-2.25c.3 0 .53.1.7.3.15.19.23.45.23.77v1.85a2.52 2.52 0 011.77-.65c.54 0 1.02.12 1.43.38.41.26.73.64.96 1.13a4.68 4.68 0 01.15 3.02c-.13.4-.3.76-.55 1.06a2.5 2.5 0 01-2 .96c-.26 0-.5-.03-.72-.1a2.13 2.13 0 01-.98-.54l-.1-.1-.03.13a.89.89 0 01-.86.6.83.83 0 01-.66-.28 1.15 1.15 0 01-.24-.78v-6.62c0-.35.07-.62.23-.82.16-.2.39-.31.67-.31zm9.7.14c.64 0 1.14.05 1.5.15a2.28 2.28 0 011.55 1.37c.13.33.2.7.2 1.12 0 .89-.28 1.57-.84 2.04-.55.46-1.35.69-2.4.69h-1.32v2.1c0 .38-.1.68-.28.89a.96.96 0 01-.74.32c-.3 0-.56-.1-.75-.32-.19-.21-.28-.5-.28-.88v-6.27c0-.41.1-.73.32-.92.2-.2.52-.3.93-.3h2.11zM18.2 18c.27 0 .5.1.69.27a.9.9 0 01.29.68c0 .17-.05.43-.13.77l-1.36 5.49-.16.62-.07.2c-.07.21-.2.4-.37.54a1.1 1.1 0 01-.75.25c-.3 0-.54-.08-.73-.24-.18-.14-.3-.31-.38-.51l-.1-.27-.16-.55-1.12-4.17-1.14 4.17-.18.61-.07.2c-.07.2-.2.37-.38.52a1.1 1.1 0 01-.73.24c-.24 0-.44-.05-.6-.14a1.1 1.1 0 01-.4-.4 2.25 2.25 0 01-.22-.54l-.14-.53-1.4-5.67a2.8 2.8 0 01-.08-.59c0-.27.1-.5.28-.68a.96.96 0 01.7-.27c.36 0 .63.13.77.4.1.17.18.4.25.7l.93 4.14 1.04-3.86.1-.34.1-.26a1.2 1.2 0 011.18-.78c.31 0 .58.08.77.25.18.16.3.33.38.53l.06.2.09.26.09.34 1 3.67.96-4.3.07-.27c.06-.17.16-.32.3-.46a.87.87 0 01.62-.22zm11.06 3.79c-.25 0-.47.06-.66.2-.2.13-.35.33-.46.6-.12.27-.18.6-.18.98 0 .56.13.98.37 1.26.23.28.54.42.93.42.32 0 .6-.14.83-.43.24-.29.37-.72.37-1.3 0-.37-.05-.69-.16-.95a1.3 1.3 0 00-.42-.59 1 1 0 00-.62-.2zm-6.94-.1c-.32 0-.58.12-.78.34-.15.15-.26.37-.33.64l-.03.18h2.3l-.04-.18c-.06-.28-.16-.5-.3-.65a1.1 1.1 0 00-.82-.32zm13.94-1.91h-.9v2.08h.9c.37 0 .68-.03.92-.1a.94.94 0 00.5-.34 1 1 0 00.16-.6c0-.32-.09-.56-.26-.74-.17-.17-.54-.28-1.12-.3h-.2zM13.15 7.87L8.12 12.9h4.13a.9.9 0 00.9-.79V7.87z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgFileBigWebp.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgFileBigWebp.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgFileBigWebp svgRef={ref} {...props} />);
export default ForwardRef;
